import axios from "axios";
import { useEffect } from "react";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API, withCredentials: true });

// Attach bearer token from localStorage
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("vyron_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export const formatINR = (n) =>
  new Intl.NumberFormat("en-IN", {
    style: "currency",
    currency: "INR",
    maximumFractionDigits: 0,
  }).format(n);

export const loadScript = (src) =>
  new Promise((resolve) => {
    if (document.querySelector(`script[src="${src}"]`)) return resolve(true);
    const s = document.createElement("script");
    s.src = src;
    s.onload = () => resolve(true);
    s.onerror = () => resolve(false);
    document.body.appendChild(s);
  });

export function formatApiError(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

function setMeta(attr, key, content) {
  let el = document.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

export function useSEO(title, description, options = {}) {
  const { image, type, jsonLd } = options;
  const jsonLdKey = JSON.stringify(jsonLd || null);
  useEffect(() => {
    const fullTitle = title ? `${title} — VYRON` : "VYRON — Luxury Eyewear";
    document.title = fullTitle;
    const desc = description || "VYRON — premium luxury sunglasses crafted in India.";
    setMeta("name", "description", desc);
    setMeta("property", "og:title", fullTitle);
    setMeta("property", "og:description", desc);
    setMeta("property", "og:type", type || "website");
    setMeta("property", "og:site_name", "VYRON");
    setMeta("property", "og:url", window.location.href);
    if (image) setMeta("property", "og:image", `${image}?w=1200&q=80`);
    setMeta("name", "twitter:card", "summary_large_image");
    setMeta("name", "twitter:title", fullTitle);
    setMeta("name", "twitter:description", desc);

    let canon = document.querySelector('link[rel="canonical"]');
    if (!canon) {
      canon = document.createElement("link");
      canon.rel = "canonical";
      document.head.appendChild(canon);
    }
    canon.href = window.location.href.split("?")[0];

    let ld = document.getElementById("vyron-jsonld");
    if (jsonLd) {
      if (!ld) {
        ld = document.createElement("script");
        ld.type = "application/ld+json";
        ld.id = "vyron-jsonld";
        document.head.appendChild(ld);
      }
      ld.textContent = JSON.stringify(jsonLd);
    } else if (ld) {
      ld.remove();
    }
  }, [title, description, image, type, jsonLdKey]); // eslint-disable-line react-hooks/exhaustive-deps
}

const RV_KEY = "vyron_recently_viewed";
export function pushRecentlyViewed(product) {
  try {
    const list = JSON.parse(localStorage.getItem(RV_KEY) || "[]").filter((p) => p.slug !== product.slug);
    list.unshift({ slug: product.slug, name: product.name, price: product.price, image: product.images?.[0], tagline: product.tagline, compare_at_price: product.compare_at_price, new_arrival: product.new_arrival });
    localStorage.setItem(RV_KEY, JSON.stringify(list.slice(0, 8)));
  } catch {}
}
export function getRecentlyViewed() {
  try {
    return JSON.parse(localStorage.getItem(RV_KEY) || "[]");
  } catch {
    return [];
  }
}
